/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Represents an environment variable configured for an MCP server.
 */
export type McpEnvironmentConfig = {
  /**
   * When the config was created
   */
  createdAt: Date;
  /**
   * Custom display name for the variable in MCP headers
   */
  headerDisplayName?: string | undefined;
  /**
   * The ID of the environment config
   */
  id: string;
  /**
   * How the variable is provided: 'user', 'system', or 'none'
   */
  providedBy: string;
  /**
   * When the config was last updated
   */
  updatedAt: Date;
  /**
   * The name of the environment variable
   */
  variableName: string;
};

/** @internal */
export const McpEnvironmentConfig$inboundSchema: z.ZodMiniType<
  McpEnvironmentConfig,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    header_display_name: z.optional(z.string()),
    id: z.string(),
    provided_by: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    variable_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "header_display_name": "headerDisplayName",
      "provided_by": "providedBy",
      "updated_at": "updatedAt",
      "variable_name": "variableName",
    });
  }),
);

export function mcpEnvironmentConfigFromJSON(
  jsonString: string,
): SafeParseResult<McpEnvironmentConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpEnvironmentConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpEnvironmentConfig' from JSON`,
  );
}
